import { render, staticRenderFns } from "./ds-slider.vue?vue&type=template&id=97593b92&"
import script from "./ds-slider.vue?vue&type=script&lang=js&"
export * from "./ds-slider.vue?vue&type=script&lang=js&"
import style0 from "./ds-slider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ds-slider.vue"
export default component.exports